module.exports = __webpack_public_path__ + "static/media/chevronTourRight.25fa6c9f.svg";